/**
 * @link https://mui.com/material-ui/react-progress/
 */

import * as React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {Divider} from "@mui/material";
import ShowCode from "../../helpers/ShowCode.js";

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position:'relative', display:'inline-flex', mb:5 }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="label" component="div" color="text.secondary">
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display:'flex', alignItems:'center', p:2, mb:3 }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body1" color="text.secondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number.isRequired,
};

export default function FactureeProgressLabel() {
  const [progress, setProgress] = React.useState(10);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
    }, 800);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <>
      <Divider textAlign={"left"}><Typography variant={"h6"}>With progress label</Typography></Divider>
      <CircularProgressWithLabel value={progress}/>
      <LinearProgressWithLabel value={progress}/>
      
      <ShowCode 
        codeString={`function ProgressWithLabelExample() {
  // Custom CircularProgress with label component
  function CircularProgressWithLabel(props) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex', mb: 5 }}>
        <CircularProgress variant="determinate" {...props} />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="label" component="div" color="text.secondary">
            {\`\${Math.round(props.value)}%\`}
          </Typography>
        </Box>
      </Box>
    );
  }

  // Custom LinearProgress with label component
  function LinearProgressWithLabel(props) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', p: 2, mb: 3 }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body1" color="text.secondary">
            {\`\${Math.round(props.value)}%\`}
          </Typography>
        </Box>
      </Box>
    );
  }

  // State and animation for progress
  const [progress, setProgress] = React.useState(10);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
    }, 800);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <>
      <Divider textAlign="left">
        <Typography variant="h6">With progress label</Typography>
      </Divider>
      <CircularProgressWithLabel value={progress} />
      <LinearProgressWithLabel value={progress} />
    </>
  );
}`} 
        scope={{ 
          React, 
          PropTypes, 
          CircularProgress, 
          LinearProgress, 
          Typography, 
          Box, 
          Divider 
        }} 
      />
    </>
  )
}
